<template>
  <v-layout row class="pr-pagination" justify-end>
    <div row v-if="paginator.numberOfPages > 1" justify-end>
      <v-btn small flat class="btn-page"
        :disabled="paginator.currentPage === 1"
        @click="paginator.goToPage(1)">{{paginator.options.labels.first}}</v-btn>
      <v-btn small flat class="btn-page"
        :disabled="paginator.currentPage === 1"
        @click="paginator.previousPage()">{{paginator.options.labels.previous}}</v-btn>
      <v-btn small flat  v-for="n in paginator.pages()"
        :class="[{'secondary': n === paginator.currentPage}, pageClass]"
        @click="paginator.goToPage(n)"
        :key="n">{{n}}</v-btn>
      <v-btn small flat class="btn-page"
        :disabled="paginator.currentPage === paginator.numberOfPages"
        @click="paginator.nextPage()">{{paginator.options.labels.next}}</v-btn>
      <v-btn small flat class="btn-page"
        :disabled="paginator.currentPage === paginator.numberOfPages"
        @click="paginator.goToPage(paginator.numberOfPages)">{{paginator.options.labels.last}}</v-btn>
    </div>
    <v-btn v-if="paginator.total > 0" small flat style="cursor: default;" disabled>
      Total: {{paginator.total}} registro(s)
    </v-btn>
  </v-layout>
</template>
<script>
  export default {
    props: {
      paginator: {
        type: Object,
      },
    },
    data() {
      return {
        pageClass: {
          'btn-page': true,
          'hidden-xs-only': true,
        },
      };
    },
  };
</script>

<style scoped lang="stylus">
  .pr-pagination .btn {
    margin: 4px 2px;
    line-height: 20px;
    min-height: 24px;
    font-size: 12px;
  }
  .pr-pagination .btn-page {
    width: 25px;
    min-width: 25px;
  }
</style>




// WEBPACK FOOTER //
// src/components/widgets/PrPagination.vue